import { useEffect, useRef, useState, type FC } from 'react';

interface ProfileAvatarProps {
  src?: string | null;
  size?: number;
  className?: string;
}

const ProfileAvatar: FC<ProfileAvatarProps> = ({
  src,
  size = 80,
  className = '',
}) => {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    setLoaded(false);
  }, [src]);

  useEffect(() => {
    if (!src) return;
    const img = imgRef.current;
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) {
      setLoaded(true);
    }
  }, [src]);

  const showSkeleton = !src || !loaded;

  return (
    <div
      className={`border-success relative overflow-hidden rounded-full border-2 ${className}`}
      style={{ width: size, height: size }}
    >
      {showSkeleton ? (
        <div className="bg-divider h-full w-full animate-pulse" />
      ) : null}
      {src ? (
        <img
          ref={imgRef}
          src={src}
          alt="Profile"
          className={`absolute inset-0 h-full w-full rounded-full object-cover ${loaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => {
            setLoaded(true);
          }}
          onError={() => {
            setLoaded(false);
          }}
        />
      ) : null}
    </div>
  );
};

export default ProfileAvatar;
